export class BlastEquipmentsData {
    tirId: number;
    equipmentIds: number[];
}
